import {Pane} from "evergreen-ui";
import React from "react";
import EvaporationPage from "./EvaporationPage";

export default function ConstructorEvaporation() {

  return (
      <Pane margin={40}>
        <EvaporationPage isFullInfo={false} isEdit={false}/>
      </Pane>
  );
}